/*
Esta página "Procesa" un mansaje, que significa crear 
un negocio a partior del mensaje.
Por lo general, el vehiculo está bien identificado, pero 
el cliente no.
muestra arriba el mensaje y abajo la ventana de creación de negocios
Autor: Benjamín León
Fecha: 2025-01-24
*/
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { fechaIsoToFull } from '../utils/utils'
import Message from '../interfaces/Message'
import useMessageFetcher from '../hooks/useMessageFetcher'
import { AppPath } from '../enums/AppPath'
import useMessagePoster from '../hooks/useMessagePoster'

import DealCreaPage from './DealCreaPage'
import { DisplayValueFormat } from './DisplayValue'

const MessageProcess: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const { fetchMessageDetail, errorMessage } = useMessageFetcher()
  const [message, setMessage] = useState<Message>()
  const { postMessageProcess, errorPostMessageProcess } = useMessagePoster()

  const navigate = useNavigate()

  useEffect(() => {
    if (!id) {
      return // Exit early if `id` is undefined
    }

    const fetchDataAsync = async () => {
      const data = await fetchMessageDetail(id)

      if (!data) return
      setMessage(data)
    }

    fetchDataAsync()
  }, [id])

  // Retorno cuando el deal (Negocio) fue creado
  const onCreateDeal = async (dealId: string) => {
    if (!dealId || !id) {
      return
    }
    // Le colocamos el "dealId" al mensaje, y por dentro,
    // el usuario seleccionado
    const result = await postMessageProcess(id, dealId)

    if (result) {
      const url = `/${AppPath.Messages}`
      navigate(url)
    }
  }

  if (!message) return
  const vehicleDesc = message.vehicle.split(' ')[0].trim()

  return (
    <div>
      <div>
        <div className="text-xl font-bold">Detalles del mensaje</div>
        <div className="grid grid-cols-1 sm:grid-cols-[auto,1fr] mb-4 gap-x-20 ">
          <DisplayValueFormat label="De" value={message.from} />
          <DisplayValueFormat label="Asunto" value={message.subject} />
          <DisplayValueFormat label="Recibido" value={fechaIsoToFull(message.createdAt)} />
          <DisplayValueFormat label="Asignado a" value={message.assignedTo_user} />
          <DisplayValueFormat label="Vehículo" value={message.vehicle} />
          <DisplayValueFormat label="Contacto" value={message.contact?.name ?? ''} />
          <DisplayValueFormat label="Teléfono" value={message.contact?.phone ?? ''} />
          <DisplayValueFormat label="Email" value={message.contact?.email ?? ''} />
        </div>

        <div className=" mb-4">
          <div className="text-xl font-bold">Cuerpo del mensaje</div>
          <div>{message.body}</div>
        </div>
      </div>
      <div>
        <DealCreaPage
          showVehCreaButton={false}
          vehicleId={message.vehicleId}
          onCreateDeal={onCreateDeal}
          vehicleDesc={vehicleDesc}
          clientDesc={message.contact?.name}
          external={message.external}
          messageId={message._id}
        />
      </div>
      <div>{errorMessage?.message}</div>
      <div>{errorPostMessageProcess?.message}</div>
    </div>
  )
}

export default MessageProcess
